import React from 'react';

const ProductSkeleton = ({ layout = 'list' }) => {
  if (layout === 'grid') {
    return (
      <div className="bg-white rounded-xl shadow-sm overflow-hidden animate-pulse">
        <div className="aspect-square bg-gray-200" />
        <div className="p-3 space-y-2">
          <div className="h-4 bg-gray-200 rounded w-3/4" />
          <div className="h-3 bg-gray-200 rounded w-1/2" />
          <div className="h-5 bg-gray-200 rounded w-1/3 mt-2" />
        </div>
      </div>
    );
  }
  
  // Layout list
  return (
    <div className="bg-white rounded-xl p-4 shadow-sm flex gap-4 animate-pulse">
      <div className="flex-1 space-y-2">
        <div className="h-5 bg-gray-200 rounded w-3/4" />
        <div className="h-3 bg-gray-200 rounded w-full" />
        <div className="h-3 bg-gray-200 rounded w-2/3" />
        <div className="h-5 bg-gray-200 rounded w-1/4 mt-2" />
      </div>
      <div className="w-24 h-24 bg-gray-200 rounded-lg flex-shrink-0" />
    </div>
  );
};

// Skeleton para seção de categoria
const CategorySkeleton = () => (
  <div className="space-y-4 animate-pulse">
    <div className="h-6 bg-gray-200 rounded w-1/3" />
    <div className="space-y-3">
      {[1, 2, 3].map(i => (
        <ProductSkeleton key={i} />
      ))}
    </div>
  </div>
);

// ============================================================
// PLACEHOLDER: Imagem de garfo e faca cruzados (idêntica à referência do usuário)
// Imagem convertida para base64 - carrega instantaneamente (~1.7KB)
// ============================================================

export { ProductSkeleton, CategorySkeleton };
